import { render, staticRenderFns } from "./sliderBrands.vue?vue&type=template&id=6406f864&scoped=true&"
import script from "./sliderBrands.vue?vue&type=script&lang=js&"
export * from "./sliderBrands.vue?vue&type=script&lang=js&"
import style0 from "./sliderBrands.vue?vue&type=style&index=0&id=6406f864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406f864",
  null
  
)

export default component.exports